const rankingItems = [
  {
    rank: 1,
    title: '暗夜追光',
    tag: '悬疑犯罪',
    update: '全24集',
    hot: true,
    desc: '年度口碑黑马，豆瓣8.7分。一桩尘封多年的连环案件，引出一场惊心动魄的正邪较量。',
  },
  {
    rank: 2,
    title: '长安浮生录',
    tag: '古装权谋',
    update: '更新至38集',
    hot: true,
    desc: '宏大历史背景下的权谋史诗，服化道精良，全员演技炸裂，全网热议追剧首选。',
  },
  {
    rank: 3,
    title: '海岸村恰恰恰',
    tag: '韩剧爱情',
    update: '全16集',
    hot: false,
    desc: '温暖治愈的海边小镇故事，甜而不腻的爱情线，每一帧都美得像明信片。',
  },
  {
    rank: 4,
    title: '星际迷途3',
    tag: '科幻动作',
    update: '高清上线',
    hot: true,
    desc: '视觉特效震撼的科幻巨制，4K修复画质带来沉浸式观影体验，电影大全必看之作。',
  },
  {
    rank: 5,
    title: '我们恋爱吧',
    tag: '甜宠爱情',
    update: '更新至22集',
    hot: false,
    desc: '轻松甜蜜的都市爱情喜剧，高颜值CP化学反应满分，是治愈剧荒的绝佳之选。',
  },
  {
    rank: 6,
    title: '迷雾追踪',
    tag: '悬疑推理',
    update: '全12集',
    hot: false,
    desc: '短小精悍的高分悬疑剧，每集一个反转，烧脑程度拉满，适合一口气追完。',
  },
  {
    rank: 7,
    title: '笑傲武林',
    tag: '古装喜剧',
    update: '更新至30集',
    hot: true,
    desc: '轻松搞笑的武侠喜剧，解压下饭必备。智能推荐帮您发现更多同类型好剧。',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-2">
            热门榜单
          </h2>
          <p className="text-sm text-foreground-500">全网热播影视排行，看看大家都在追什么</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {rankingItems.map((item) => (
            <a
              key={item.rank}
              href="#index"
              className="group flex items-start gap-3 md:gap-4 bg-background-100 rounded-xl p-4 md:p-5 border border-background-200/70 hover:border-primary-300 hover:shadow-md transition-all cursor-pointer"
            >
              {/* Rank number */}
              <div
                className={`flex-shrink-0 w-8 h-8 md:w-10 md:h-10 rounded-lg flex items-center justify-center font-heading font-bold text-sm md:text-base ${
                  item.rank === 1
                    ? 'bg-accent-500 text-background-50'
                    : item.rank === 2
                    ? 'bg-primary-500 text-background-50'
                    : item.rank === 3
                    ? 'bg-secondary-500 text-background-50'
                    : 'bg-background-200 text-foreground-500'
                }`}
              >
                {item.rank}
              </div>

              {/* Content */}
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap mb-1">
                  <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <span className="px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium">
                    {item.tag}
                  </span>
                  {item.hot && (
                    <span className="inline-flex items-center gap-1 text-xs text-accent-600">
                      <i className="ri-fire-line"></i>
                      热播
                    </span>
                  )}
                </div>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>

              {/* Update info */}
              <span className="flex-shrink-0 text-xs text-foreground-400 mt-1 whitespace-nowrap">
                {item.update}
              </span>
            </a>
          ))}
        </div>

        <div className="text-center mt-8">
          <a
            href="#index"
            className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer"
          >
            查看完整榜单
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}